export const ALERT_BY_STATUS = {
  INITIATED: 'info',
  IN_PROGRESS: 'info',
  OPENED: 'info',
  PROCESSING: 'info',
  APPROVED: 'info',
  PENDING: 'info',
  GOOD_PARTIAL_MATCH: 'info',
  IN_PROCESS: 'info',
  PRE_VIDEO_CALL: 'info',
  VIDEO_CALL: 'info',
  AGENT_REVIEWED: 'info',
  AUDITOR_REVIEWED: 'info',

  FAILED: 'danger',
  VERIFICATION_FAILED: 'danger',
  EXPIRED: 'danger',
  INVALID: 'danger',
  TRANSFER_REVERSAL: 'danger',
  UNABLE_TO_VALIDATE: 'danger',
  REJECTED: 'danger',
  MANUALLY_REJECTED: 'danger',
  VALIDATION_FAILED: 'danger',
  REVERSED: 'danger',
  CANCELLED: 'danger',
  NO_MATCH: 'danger',
  IMPS_MODE_FAIL: 'danger',
  INVALID_IFSC: 'danger',
  BENE_BANK_DOWN: 'danger',
  BENE_BANK_DECLINED: 'danger',
  REQUEST_TIMED_OUT: 'danger',
  NRE_ACCOUNT: 'danger',
  ACCOUNT_BLOCKED: 'danger',
  BANK_GATEWAY_ERROR: 'danger',
  OTHERS: 'danger',
  INACTIVE: 'danger',
  FAILURE: 'danger',
  DISABLED: 'danger',

  ACTIVE: 'success',
  PROCESSED: 'success',
  SUCCESS: 'success',
  COMPLETED: 'success',
  REDEEMED: 'success',
  VALID: 'success',
  DIRECT_MATCH: 'success',
  RECEIVED: 'success',
  VERIFIED: 'success',
  PUBLISHED: 'success',
  ENABLED: 'success',

  PENDING_APPROVAL: 'warning',
  PARTIALLY_APPROVED: 'warning',
  VERIFICATION_PENDING: 'warning',
  MODERATE_PARTIAL_MATCH: 'warning',
  OTP_EXPIRED: 'warning',
  AVAILABLE_FREE_CREDITS: 'warning',
  AWAITING_CNF: 'warning',
  DRAFT: 'warning',

  POOR_PARTIAL_MATCH: 'bodyLight',
};

export const LABEL_BY_STATUS = {
  CANCELLED: 'Cancelled',
  OPENED: 'Opened',
  RECHARGES: 'Recharges',
  WITHDRAWAL: 'Withdrawal',
  INTERNAL_TRANSFERS: 'Internal Transfers',
  PAYOUT_REVERSALS: 'Payouts Reversals',
  INITIATED: 'Initiated',
  IN_PROGRESS: 'In Progress',
  PROCESSING: 'Processing',
  PROCESSED: 'Processed',
  FAILED: 'Failed',
  VERIFICATION_FAILED: 'Verification Failed',
  FAILED_VALIDATIONS: 'Failed Validations',
  UNABLE_TO_VALIDATE: 'Unable To Validate',
  WAITING: 'Waiting',
  EXPIRED: 'Expired',
  SUCCESS: 'Success',
  COMPLETED: 'Completed',
  REVERSED: 'Reversed',
  REDEEMED: 'Redeemed',
  ACTIVE: 'Active',
  REJECTED: 'Rejected',
  MANUALLY_REJECTED: 'Manually Rejected',
  ABORTED: 'Aborted',
  PENDING: 'Pending',
  PENDING_APPROVAL: 'Pending Approval',
  PARTIALLY_APPROVED: 'Partially Approved',
  VALID: 'Valid',
  INVALID: 'Invalid',
  YES: 'Yes',
  NO: 'No',
  VERIFICATION_PENDING: 'Verification Pending',
  AUTOCOLLECT_SETTLEMENT: 'Autocollect Settlements',
  SELF_WITHDRAWAL: 'Self Withdrawal',
  SERVICE_FEE: 'Service Fee',
  SETUP_FEE: 'Setup Fee',
  TRANSFER_REVERSAL: 'Reversed',
  PYTM_TRANSFER_REVERSAL: 'Reversed',
  PAYOUT_TRANSFER: 'Cashfree Transfer',
  PYTM_PAYOUT_TRANSFER: 'Cashfree Transfer',
  BANK_TRANSFER: 'Bank Transfers',
  BANKDETAILS_VALIDATION: 'Bank Details Verification',
  BANKDETAILSVALIDATION_SQL: 'Bank Details Verification',
  BANKVALIDATION_DEBIT: 'Bank Details Verification',
  BANKDETAILSVALIDATION_JAN: 'Bank Details Verification',
  BANKVALIDATION_CREDIT: 'Bank Details Verification Credit',
  INTERNAL_TRANSFER_IN: 'Internal Transfers (IN)',
  INTERNAL_TRANSFER_OUT: 'Internal Transfers (OUT)',
  UPIDETAILS_VALIDATION: 'UPI Details Verification',
  PG_INSTANT_SETTLEMENT: 'PG Instant Settlements',
  CASHGRAM_C: 'Cashgram Creation',
  CASHGRAM_CV: 'Cashgram Creation and Validation',
  CASHGRAM_CVT: 'Cashgram Creation, Validation and Transfer',
  CASHGRAM_CT: 'Cashgram Creation and Transfer',
  CASHGRAM_R: 'Cashgram Reversal',
  FUND_SWEEP: 'Cashfree Auto Recharge',
  PG_SETTLEMENT: 'PG Settlement',
  FRTL_PAYOUT_TRANSFER: 'Cashfree Transfer',
  FRTL_TRANSFER_REVERSAL: 'Transfer Reversal',
  DELAYED_DIFF_DEBIT: 'Delayed differential Debit',
  DELAYED_DIFF_CREDIT: 'Delayed differential Credit',
  PANDETAILS_VERIFICATION: 'PAN Details Verification',
  AADHAAR_VERIFICATION: 'Aadhaar Details Verification',
  GSTINDETAILS_VERIFICATION: 'GSTIN Details Verification',
  OFFLINE_AADHAAR_V: 'Aadhaar OKYC',
  DIRECT_MATCH: 'Direct Match',
  GOOD_PARTIAL_MATCH: 'Good Partial Match',
  MODERATE_PARTIAL_MATCH: 'Moderate Partial Match',
  POOR_PARTIAL_MATCH: 'Poor Partial Match',
  NO_MATCH: 'No Match',
  OTP_EXPIRED: 'OTP Expired',
  IMPS_MODE_FAIL: 'IMPS Mode Failed',
  INVALID_IFSC: 'Invalid IFSC',
  BENE_BANK_DOWN: 'Bene Bank Down',
  BENE_BANK_DECLINED: 'Bene Bank Declined',
  REQUEST_TIMED_OUT: 'Request Timed Out',
  NRE_ACCOUNT: 'NRE Account',
  ACCOUNT_BLOCKED: 'Account Blocked',
  BANK_GATEWAY_ERROR: 'Bank Gateway Error',
  OTHERS: 'Others',
  AVAILABLE_FREE_CREDITS: 'Available Free Credits',
  AWAITING_CNF: 'Awaiting Confirmation',
  APPROVAL_PENDING: 'Approval Pending',
  RECEIVED: 'Received',
  FAILURE: 'Failure',
  IN_PROCESS: 'In Process',
  VALIDATION_FAILED: 'Validation Failed',
  VERIFIED: 'Verified',
  PUBLISHED: 'Published',
  DRAFT: 'Draft',
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  PRE_VIDEO_CALL: 'Pre Video Call',
  VIDEO_CALL: 'Video Call',
  AGENT_REVIEWED: 'Agent Reviewed',
  AUDITOR_REVIEWED: 'Auditor Reviewed',
};
